import { styled } from '@mui/styles'
import { useAppDispatch } from '../../store/hooks'
import { RootState } from '../../store/store'
import { useSelector } from 'react-redux'
import { FieldContainer } from '../ui/FIeldContainer'
import { Label } from '../ui/Label'
import { Button, Input } from 'antd'
import { ChangeEvent } from 'react'
import {
    ActiveModal,
    AssemblyFieldFilters,
    openModal,
    setAssemblyFieldFilters,
} from '../../store/products-slice'

const Container = styled('div')(() => ({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
}))

const InputsContainer = styled('div')(() => ({
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    padding: '0px 0px 10px 0px',
    gap: '5px',
}))

const ActionsContainer = styled('div')(() => ({
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    padding: '0px 0px 10px 0px',
    gap: '5px',
}))

export const AssemblyFieldsTopBar = () => {
    const { assemblyFieldFilters } = useSelector((state: RootState) => state.products)
    const dispatch = useAppDispatch()

    const mutateAssemblyFieldsFilters = (
        key: keyof AssemblyFieldFilters,
        value: string | number | undefined
    ) => {
        dispatch(setAssemblyFieldFilters({ ...assemblyFieldFilters, [key]: value }))
    }

    return (
        <Container>
            <InputsContainer>
                <FieldContainer>
                    <Label>Id</Label>
                    <Input
                        style={{ width: '150px' }}
                        value={assemblyFieldFilters.assemblyFieldId}
                        onChange={(event: ChangeEvent<HTMLInputElement>): void => {
                            if (
                                isNaN(parseInt(event.target.value)) ||
                                parseInt(event.target.value) === 0
                            ) {
                                mutateAssemblyFieldsFilters('assemblyFieldId', undefined)
                            } else {
                                mutateAssemblyFieldsFilters(
                                    'assemblyFieldId',
                                    Number(event.target.value)
                                )
                            }
                        }}
                    />
                </FieldContainer>
                <FieldContainer>
                    <Label>Name</Label>
                    <Input
                        style={{ width: '200px' }}
                        value={assemblyFieldFilters.name}
                        onChange={(event: ChangeEvent<HTMLInputElement>): void => {
                            mutateAssemblyFieldsFilters('name', event.target.value)
                        }}
                    />
                </FieldContainer>
            </InputsContainer>
            <ActionsContainer>
                <Button
                    type="primary"
                    onClick={() => {
                        dispatch(openModal({ activeModal: ActiveModal.AssemblyFieldCreate }))
                    }}
                >
                    Create Assembly Field
                </Button>
            </ActionsContainer>
        </Container>
    )
}
